import api from '../api'

export const postBreeder = params => api.post('/admin/breeders', params)

export const putBreeder = ({ id, ...params }) => api.put(`/admin/breeders/${ id }`, params)

export const postCultivar = params => api.post('/admin/cultivars', params)

export const putCultivar = ({ id, ...params }) => api.put(`/admin/cultivars/${ id }`, params)

export const deleteCultivar = ({ id }) => api.delete(`/admin/cultivars/${ id }`)
